import React from 'react';
import { Bold, Italic, Heading2, Heading3, List, ListOrdered } from 'lucide-react';

/**
 * Admin-only formatting toolbar for the SOP editor. Rendered only in 'full'
 * mode; clients never see it (their editing is text-only within steps).
 */
const SopEditorToolbar = ({ editor }) => {
  if (!editor) return null;

  const Btn = ({ onClick, active, disabled, title, children }) => (
    <button
      type="button"
      title={title}
      aria-label={title}
      disabled={disabled}
      onMouseDown={(e) => e.preventDefault()}
      onClick={onClick}
      className={`sop-toolbar-btn${active ? ' is-active' : ''}`}
    >
      {children}
    </button>
  );

  return (
    <div className="sop-toolbar">
      <Btn
        title="Bold"
        active={editor.isActive('bold')}
        onClick={() => editor.chain().focus().toggleBold().run()}
      >
        <Bold className="w-4 h-4" />
      </Btn>
      <Btn
        title="Italic"
        active={editor.isActive('italic')}
        onClick={() => editor.chain().focus().toggleItalic().run()}
      >
        <Italic className="w-4 h-4" />
      </Btn>

      <span className="sop-toolbar-divider" />

      <Btn
        title="Heading"
        active={editor.isActive('heading', { level: 2 })}
        onClick={() => editor.chain().focus().toggleHeading({ level: 2 }).run()}
      >
        <Heading2 className="w-4 h-4" />
      </Btn>
      <Btn
        title="Subheading"
        active={editor.isActive('heading', { level: 3 })}
        onClick={() => editor.chain().focus().toggleHeading({ level: 3 }).run()}
      >
        <Heading3 className="w-4 h-4" />
      </Btn>

      <span className="sop-toolbar-divider" />

      <Btn
        title="Bullet list"
        active={editor.isActive('bulletList')}
        onClick={() => editor.chain().focus().toggleBulletList().run()}
      >
        <List className="w-4 h-4" />
      </Btn>
      <Btn
        title="Numbered list"
        active={editor.isActive('orderedList')}
        onClick={() => editor.chain().focus().toggleOrderedList().run()}
      >
        <ListOrdered className="w-4 h-4" />
      </Btn>
    </div>
  );
};

export default SopEditorToolbar;
